import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface AddressState {
  selectedAddress: string;
}

const initialState: AddressState = {
  selectedAddress: "",
};

export const addressSlice = createSlice({
  name: "address",
  initialState,
  reducers: {
    setSelectedAddress: (state, action: PayloadAction<string>) => {
      state.selectedAddress = action.payload;
    },
    clearSelectedAddress: (state) => {
      state.selectedAddress = "";
    },
  },
});

export const { setSelectedAddress, clearSelectedAddress } = addressSlice.actions;
export default addressSlice.reducer;
